import { request } from "../../api/config";
import { DefaultIndexParams } from "../../types/common";

export const getRegions = async (params?: DefaultIndexParams) => {
  const { data } = await request.get("/manage-asesmen/regions", { params });
  return data;
};

export const getPsikologRegions = async (
  params?: DefaultIndexParams & { region_id?: string }
) => {
  const { data } = await request.get("/select/psikolog-region", { params });
  return data;
};

export const createRegion = async (payload: any) => {
  return request.post(`/manage-asesmen/region`, payload);
};

export const updateRegion = async (id: string | number, payload: any) => {
  return request.put(`/manage-asesmen/region/${id}`, payload);
};

export const deleteRegion = async (id: string | number) => {
  return request.delete(`/manage-asesmen/region/${id}`);
};

export const createLocation = async (payload: any) => {
  return request.post(`/manage-asesmen/place`, payload);
};

export const updateLocation = async (id: string, payload: any) => {
  return request.put(`/manage-asesmen/place/${id}`, payload);
};

export const deleteLocation = async (id: string) => {
  return request.delete(`/manage-asesmen/place/${id}`);
};

export const getLocations = async (params?: DefaultIndexParams) => {
  const { data } = await request.get("/manage-asesmen/places", { params });
  return data;
};
